import api from ".";
import { ICriteriaGroup } from "../types/criteriaGroup";
import cookiesModifier from "../utils/cookies";

export const getAllCriteriaGroups = async () => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`criteria-groups`);

        return res.data as ICriteriaGroup[];
    } catch (error) {
        throw error;
    }
}

export const getCriteriaGroup = async (questCode: string) => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`criteria-groups/tree/${questCode}`);

        return res.data as ICriteriaGroup[];
    } catch (error) {
        throw error;
    }
}

export const createCriteriaGroup = async (data: ICriteriaGroup) => {
    const url = `criteria-groups`;
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateCriteriaGroup = async (data: ICriteriaGroup) => {
    try {
        const { id, ...payload } = data;
        const url = `criteria-groups/${id}`;
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.patch(url, payload);

        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteCriteriaGroup = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`criteria-groups/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}